import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAppointment, removeAppointment } from 'slice/appointmentSlice';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';
import { getSocket } from 'common/socket';

const getStatusLabel = (status) => {
    const parsed = Number.parseInt(status, 10);

    if (parsed === 1) return 'Booked';
    if (parsed === 0) return 'Cancelled';
    if (parsed === 2) return 'Completed';

    return `Unknown (${status})`;
};

const Appointment = () => {
    const dispatch = useDispatch();
    const cartData = useSelector((state) => state.appointments);



    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: ' Patient Name',
            accessor: 'name',
        },
        {
            Header: 'Current Illness',
            accessor: 'illness',
        },

        {
            Header: 'Consultation Type',
            accessor: 'consultation_type',
        },
        {
            Header: 'Appointment Date',
            accessor: 'appointment_date',
        },
        {
            Header: 'Appointment Time',
            accessor: 'appointment_time',
        },
        {
            Header: 'Phone Number',
            accessor: 'patient_mobile',
        },
        {
            Header: 'Payment Id',
            accessor: 'payment_id',
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ row }) => getStatusLabel(row.original.status)
        },
        {
            Header: 'Address',
            accessor: 'address',
        },
        {
            Header: 'Message',
            accessor: 'message',
            Cell: ({ row }) => <TruncatedMessage text={row.original.message} maxLength={10} />
        },

        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <button
                    className="btn removebtn"
                    onClick={() => dispatch(removeAppointment(row.original.id))}
                >
                    Remove
                </button>
            ),
        },
    ];
    useEffect(() => {
        const refreshAppointments = () => {
            dispatch(getAppointment());
        };

        refreshAppointments();

        let socket;

        try {
            socket = getSocket();
        } catch (socketError) {
            console.warn('Socket connection unavailable for appointment updates.', socketError);
            return undefined;
        }

        socket.on('new-appointment', refreshAppointments);

        return () => {
            socket.off('new-appointment', refreshAppointments);
        };
    }, [dispatch]);

    // useEffect(()=>{
    //     window.location.reload()
    // }, [cartData?.data?.length])

    return (
        <>
            <div className="container-fluid mt-5 pb-5">
                <div className="mainheadig mx-3">
                    <h4 className="text-white font-weight-bold">Appointments List</h4>
                </div>
                {cartData?.data?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                ) : 'Loadin.......'}
            </div>
        </>
    );
};

export default Appointment;
